import React, { Suspense, useState, useEffect } from "react";
import systemListingService from "./SystemListingServices";
import { MechanicalRateDrawer } from "../../AssetLinking/MenuDrawer";
import Pagination from "components/Common/newPagination";
import { Filter } from "filter";
import MechanicalRateUpsert from "./upsert/MechanicalRateUpsert";
import DeleteDialogueBox from "components/Common/deleteDialogue";
import { CommonUtilities } from "commonUtils";

export default function MechanicalRate(param: any) {

  let [mechRateCount, SetmechRateCount] = useState(0);
  let [clientZones, SetclientZones] = useState<any>([]);
  let [searchZone, setSearchZone] = useState<string>("");
  let [systemFormat, SetsystemFormat] = useState<any>([]);
  let [editingOn, setEditingOn] = useState<boolean>(false);
  let [mechRateListing, SetmechRateListing] = useState<any>([]);
  let [searchFormatCode, setSearchFormatCode] = useState<string>("");

  useEffect(() => {

    if (param.activeTab === "Mechanical Rate") {
      systemListingService.getAllClientZones({}).then((res: any) => {
        SetclientZones(res)
      })
      systemListingService.systemFormatsList().then((res: any) => {
        SetsystemFormat(res)
      })
    }
  }, [param])

  var payload = {
    pageNumber: 1,
    pageSize: 10,
    format: searchFormatCode,
    territoryCode: searchZone
  }

  const mechRateSelect = () => {
    mechRateListing = [];
    SetmechRateListing(mechRateListing)

    mechRateCount = 0

    systemListingService.MechanicalRateCount(payload).then((res: any) => {

      if (res > 0) {
        mechRateCount = res
        SetmechRateCount(mechRateCount)
        systemListingService.MechanicalRateListing(payload).then((res: any) => {
          mechRateListing = res;
          SetmechRateListing(mechRateListing)
        })
      }
    })
  }

  const onPageChange = (e: any) => {
    console.log(e)
    payload.pageNumber = e.pageNumber;
    payload.pageSize = e.pageSize;
    mechRateSelect();
  }

  let [openUpsertUX, setOpenUpsertUX] = useState(false);
  let [editDataDawer, seteditDataDawer] = useState<any>([]);

  const openAddDrawer = (e: any) => {
    editDataDawer = e
    seteditDataDawer(editDataDawer)
    openUpsertUX = true
    setOpenUpsertUX(openUpsertUX)
  };

  const closeUpsertUX = () => {
    setOpenUpsertUX(!openUpsertUX)
  }

  let [deleteData, setDeleteData] = useState<any>([]);
  let [deleteStatus, setDeleteStatus] = useState(false);
  const deleteSelection = (e: any) => {
    console.log(e)
    deleteData = e
    setDeleteData(deleteData)

    deleteStatus = true;
    setDeleteStatus(deleteStatus)
  }

  const deleteConfirmation = (e: any) => {
    console.log(e)

    //e==1 YES
    if (e == 1) {
      systemFormatsList.deleteMechRate(deleteData).then((respond: any) => {
        CommonUtilities.showToastDawer('Mechanical Rate delete Successfull', 'Success')
      })
    }
    //e==2 NO
    deleteStatus = false;
    setDeleteStatus(deleteStatus)
  }

  const export_mechRate = () => {
    systemListingService.mechRateExport({ format: "", territoryCode: "", export: 1 })
  }

  return (
    <div className="content-card ws-12">
 
      <div className=" ws-12">
        <div className="card-title">Mechanical Rate</div>

        <div className="ws-12 mb">
          <span className="pt mt pull-left">{mechRateCount} record(s) found  </span>
          <button className="icon-btn info pull-right" id="editModeBtn" type="button" onClick={() => setEditingOn((prev) => !prev)}> {editingOn ? "Edit Mode: On" : "Edit Mode: Off"}  </button>
        </div>
      </div>

      <div className="ws-12 ptl mt">

        <div className="ws-8">

          <div className="ws-6">
            <label className="text-bold ws-12">Format/Source Codes</label>

            <select className="ws-8" value={searchFormatCode} onChange={(e) => setSearchFormatCode(e.target.value)} >
              <option value="">Select Format/Source Codes</option>
              {systemFormat.map((opt: any) => (
                <option key={opt.formatDesc} value={opt.formatDesc}>
                  {opt.formatDesc}
                </option>
              ))}
            </select>

          </div>

          <div className="ws-6">
            <label className="text-bold ws-12">Zone </label>
            <select className="ws-8" value={searchZone} onChange={(e) => setSearchZone(e.target.value)}>
              <option value="">Select Zone</option>
              {clientZones.map((opt: any) => (
                <option key={opt.zoneID} value={opt.zoneID}>
                  {opt.zoneID}
                </option>
              ))}
            </select>
          </div>

        </div>

        <div className="ws-4 heigh35">
          <button className="icon-btn primary fill pull-right heigh35" onClick={() => openAddDrawer({})}>Add Mech Rate</button>
          <button className="icon-btn primary pull-right heigh35" onClick={() => mechRateSelect()}>Search</button>
          <button className="icon-btn primary height35 pull-right" onClick={export_mechRate}> <i className="icon-download1"></i></button>
        </div>

      </div>

      <div className="ws-12 ptl mt">

        <div className="allowHscroll">
          {mechRateCount > 0 && <table className="newTable ">
            <thead>
              <tr className="forceSingleLine">
                <th >Exch Rate</th>
                <th style={{ width: "20%" }}>Fixed Rate</th>
                <th >Format/Source</th>
                <th >Home Rate1</th>
                <th >Home Rate2</th>
                <th >PerMinThereafter</th>
                <th >PerSubscriber</th>
                <th >PercRevenue</th>
                <th >Rate Based on</th>
                <th >Sub Format</th>
                <th>Zone</th>
                <th >Date Up To</th>
                <th >Operation</th>
              </tr>
            </thead>
            <tbody>
              {mechRateListing.map((rate: any) => (
                <tr >
                  <td>{rate.exchRate}</td>
                  <td>{rate.fixedRate}</td>
                  <td>{rate.formatCode}</td>
                  <td>{rate.homeRate1}</td>
                  <td>{rate.homeRate2}</td>
                  <td>{rate.perMinThereafter}</td>
                  <td>{rate.perSubscriber}</td>
                  <td>{rate.percRevenue}</td>
                  <td className="forceSingleLine">{rate.rateBasedon}</td>
                  <td>{rate.subFormat}</td>
                  <td>{rate.territoryCode}</td>
                  <td className="forceSingleLine">{Filter.monthAndDayYear(rate.dateUpto)}</td>
                  <td style={{ pointerEvents: editingOn ? "auto" : "none", opacity: editingOn ? 1 : 0.6, cursor: editingOn ? "pointer" : "not-allowed", }}>

                    <div style={{ width: '90px', whiteSpace: 'nowrap' }} className="width140">
                      <button className="icon-btn edit" title="Edit " type="button" onClick={() => openAddDrawer(rate)} disabled={!editingOn} >
                        <i className="icon-pencil"></i>
                      </button>

                      <button className="icon-btn delete" title="Delete" type="button" disabled={!editingOn} onClick={() => deleteSelection(rate)}>
                        <i className="icon-trash"> </i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>}

        </div>
        {mechRateCount === 0 && <div className="alert alert-info ws-12 box" >No records to display</div>}

        {(mechRateCount > 0 && mechRateCount > 10) && <Pagination totalRow={mechRateCount} onPageChange={onPageChange} />}
      </div>

      {
        (() => {
          if (openUpsertUX) {
            return <MechanicalRateUpsert openUpsertUX={openUpsertUX} closeDrawer={closeUpsertUX} editDataDawer={editDataDawer} />
          }

          if (deleteStatus) {
            return <DeleteDialogueBox param={deleteStatus} message={"delete mech rate with format code: " + deleteData?.subFormat + " : " + deleteData?.territoryCode} onChange={deleteConfirmation} />
          }

        })()
      }
    </div>

  );
};